import { render, staticRenderFns } from "./editExamPaper.vue?vue&type=template&id=0003c002&scoped=true&"
import script from "./editExamPaper.vue?vue&type=script&lang=js&"
export * from "./editExamPaper.vue?vue&type=script&lang=js&"
import style0 from "./editExamPaper.vue?vue&type=style&index=0&id=0003c002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0003c002",
  null
  
)

export default component.exports